import { render, staticRenderFns } from "./episode.vue?vue&type=template&id=27a41b72&scoped=true&"
import script from "./episode.vue?vue&type=script&lang=js&"
export * from "./episode.vue?vue&type=script&lang=js&"
import style0 from "./episode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./episode.vue?vue&type=style&index=1&id=27a41b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a41b72",
  null
  
)

export default component.exports